import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'

interface IFillingLineBreakProps {

}

export const FillingLineBreak: React.FC<IFillingLineBreakProps> = ({ }) => {
  return (
    <>
      <Flex style={{ width: '100%', height: '2px', backgroundColor: '#344f79' }} />
    </>);
}